// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/utils/provider/NonceContext.tsx"
);
import.meta.hot.lastModified = "1723813385000";
}
// REMIX HMR END

import { createContext } from "react";

export const NonceContext = createContext("");
